import { generateActions } from '../utils'
import { API_CONST } from '../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  personInfo: {},
  initPerson: false
}

const getActions = generateActions('persons/info/GET_PERSON_INFO')


export const getPersonInfo = createAction(
  API_CONST,
  () => ({
    actions: getActions,
    url: 'auth/person'
  })
)



export default handleActions({
  [getActions[0]]: state => ({ ...initial }),
  [getActions[1]]: (state, { payload = {} }) => ({
    ...state,
    personInfo: payload,
    initPerson: true
  }),
  [getActions[2]]: state => ({
    ...initial,
    initPerson: true
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/personProfile.js